import { ICalendarHolidayData, ITimeOffCalendarData } from '@/models';
import {
  IFetchCalendarHolidaysParams,
  IUploadCalendarHolidaysParams
} from '@/services/timeoff-calendar';
import { ICalendarTimeOffHolidaysData } from '../timeoff-calendar.types';

import {
  ITimeOffCalendarActions,
  TimeOffCalendarContext
} from './actions.types';

export const actions: ITimeOffCalendarActions = {
  fetchTimeOffCalendars(context: TimeOffCalendarContext): Promise<void> {
    return this.$services.timeOffCalendar
      .fetchTimeOffCalendars()
      .then((calendars: ITimeOffCalendarData[]) => {
        context.commit('SET_CALENDAR_YEARS', calendars);
      });
  },

  fetchTimeOffCalendar(
    context: TimeOffCalendarContext,
    payload: number
  ): Promise<void> {
    return this.$services.timeOffCalendar
      .fetchTimeOffCalendar(payload)
      .then((calendar: ITimeOffCalendarData) => {
        const index = context.state.calendars.findIndex(
          (v: ITimeOffCalendarData) => v.id === calendar.id
        );
        if (index === -1) {
          context.commit('ADD_CALENDAR_YEAR', calendar);
        } else {
          context.commit('UPDATE_CALENDAR_YEAR', calendar);
        }
      });
  },

  createTimeOffCalendar(
    context: TimeOffCalendarContext,
    payload: ITimeOffCalendarData
  ): Promise<void> {
    return this.$services.timeOffCalendar
      .createTimeOffCalendar(payload)
      .then((calendar: ITimeOffCalendarData) =>
        context.commit('ADD_CALENDAR_YEAR', calendar)
      );
  },

  updateTimeOffCalendar(
    context: TimeOffCalendarContext,
    payload: ITimeOffCalendarData
  ): Promise<void> {
    return this.$services.timeOffCalendar
      .updateTimeOffCalendar(payload)
      .then((calendar: ITimeOffCalendarData) => {
        const index = context.state.calendars.findIndex(
          (v: ITimeOffCalendarData) => v.id === calendar.id
        );
        if (index === -1) {
          context.commit('ADD_CALENDAR_YEAR', calendar);
        } else {
          context.commit('UPDATE_CALENDAR_YEAR', calendar);
        }
      });
  },

  deleteTimeOffCalendar(
    context: TimeOffCalendarContext,
    payload: number
  ): Promise<void> {
    return this.$services.timeOffCalendar
      .deleteTimeOffCalendar(payload)
      .then(() => {
        context.commit('REMOVE_CALENDAR_YEAR', payload);
      });
  },

  //holidays
  fetchCalendarHolidays(
    context: TimeOffCalendarContext,
    params: IFetchCalendarHolidaysParams
  ): Promise<void> {
    return this.$services.timeOffCalendar
      .fetchCalendarHolidays(params)
      .then((calendarHolidays: ICalendarHolidayData[]) => {
        context.commit('SET_CALENDAR_HOLIDAYS', {
          calendar: params.calendarId,
          holidays: calendarHolidays
        } as ICalendarTimeOffHolidaysData);
      });
  },

  fetchCalendarHoliday(
    context: TimeOffCalendarContext,
    payload: { calendarId: number; holidayId: number }
  ): Promise<void> {
    return this.$services.timeOffCalendar
      .fetchCalendarHoliday(payload.calendarId, payload.holidayId)
      .then((calendarHoliday: ICalendarHolidayData) => {
        const index = context.state.calendarHolidays.findIndex(
          (v: ICalendarTimeOffHolidaysData) => v.calendar === payload.calendarId
        );
        if (index === -1) {
          context.commit('ADD_CALENDAR_HOLIDAY', {
            calendar: payload.calendarId,
            holidays: calendarHoliday
          } as ICalendarTimeOffHolidaysData);
        } else {
          context.commit('UPDATE_CALENDAR_HOLIDAY', {
            calendar: payload.calendarId,
            holidays: calendarHoliday
          } as ICalendarTimeOffHolidaysData);
        }
      });
  },

  createCalendarHoliday(
    context: TimeOffCalendarContext,
    payload: { calendarId: number; data: ICalendarHolidayData }
  ): Promise<void> {
    return this.$services.timeOffCalendar
      .createCalendarHoliday(payload.calendarId, payload.data)
      .then((calendarHoliday: ICalendarHolidayData) =>
        context.commit('ADD_CALENDAR_HOLIDAY', {
          calendar: payload.calendarId,
          holidays: calendarHoliday
        } as ICalendarTimeOffHolidaysData)
      );
  },

  updateCalendarHoliday(
    context: TimeOffCalendarContext,
    payload: { calendarId: number; data: ICalendarHolidayData }
  ): Promise<void> {
    return this.$services.timeOffCalendar
      .updateCalendarHoliday(payload.calendarId, payload.data)
      .then((calendarHoliday: ICalendarHolidayData) => {
        const index = context.state.calendarHolidays.findIndex(
          (v: ICalendarTimeOffHolidaysData) => v.calendar === payload.calendarId
        );

        if (index === -1) {
          context.commit('ADD_CALENDAR_HOLIDAY', {
            calendar: payload.calendarId,
            holidays: calendarHoliday
          } as ICalendarTimeOffHolidaysData);
        } else {
          context.commit('UPDATE_CALENDAR_HOLIDAY', {
            calendar: payload.calendarId,
            holidays: calendarHoliday
          } as ICalendarTimeOffHolidaysData);
        }
      });
  },

  deleteCalendarHoliday(
    context: TimeOffCalendarContext,
    payload: { calendarId: number; calendarHoliday: ICalendarHolidayData }
  ): Promise<void> {
    return this.$services.timeOffCalendar
      .deleteCalendarHoliday(payload.calendarId, payload.calendarHoliday.id!)
      .then(() => {
        context.commit('REMOVE_CALENDAR_HOLIDAY', {
          calendar: payload.calendarId,
          holidays: payload.calendarHoliday
        } as ICalendarTimeOffHolidaysData);
      });
  },

  uploadCalendarHolidays(
    _context: TimeOffCalendarContext,
    params: IUploadCalendarHolidaysParams
  ): Promise<void> {
    return this.$services.timeOffCalendar
      .uploadCalendarHolidays(params)
      .then(() => {});
  }
};
